// src/components/Hero.jsx
import React, { useState, useEffect } from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'; // Íconos modernos
import { BsDot } from 'react-icons/bs'; // Dot elegante para la paginación

const images = [
  '/assets/images/Hero/1-bottelhero.webp',
  '/assets/images/Hero/2-mealboxhero.webp',
  '/assets/images/Hero/3-jackethero.webp',
  '/assets/images/Hero/4-cubbyhero.webp',
  '/assets/images/Hero/5-desktophero.webp',
  '/assets/images/Hero/6-doghero.webp',
  '/assets/images/Hero/7-keyshero.webp',
  '/assets/images/Hero/8-wallethero.webp',
  '/assets/images/Hero/9-container.webp',
  '/assets/images/Hero/10-Bikehero.webp',
  '/assets/images/Hero/11-Airhero.webp',
  '/assets/images/Hero/12-instrumenthero.webp',
];

export default function Hero({ language = "en" }) {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
const [accessibleMode, setAccessibleMode] = useState(
  () => JSON.parse(localStorage.getItem('accessibleMode')) || false
);

//medicion de altura de header
useEffect(() => {
  const setVhProperty = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  setVhProperty(); // Set inicial
  window.addEventListener('resize', setVhProperty); // Set dinámico en resize

  return () => window.removeEventListener('resize', setVhProperty);
}, []);


useEffect(() => {
  localStorage.setItem('accessibleMode', JSON.stringify(accessibleMode));
}, [accessibleMode]);

useEffect(() => {
  if (paused || accessibleMode) return;
  const interval = setInterval(() => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, accessibleMode ? 20000 : 6000);
  return () => clearInterval(interval);
}, [paused, accessibleMode]);

  const nextSlide = () => setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const altTexts = {
  es: [
    "Botella metálica con código QR en el asa.",
    "Lonchera escolar azul con etiqueta QR.",
    "Chaqueta colgada con código QR en el bolsillo.",
    "Casillero escolar con mochilas y etiquetas QR.",
    "Escritorio moderno con laptop y artículo QR.",
    "Perro pug con collar y placa de identificación QR.",
    "Juego de llaves con llavero metálico QR.",
    "Billetera de cuero abierta con código QR grabado.",
    "Contenedor deportivo naranja con logotipo y QR.",
    "Bicicleta de montaña con código QR grabado en el cuadro.",
	"Maleta con codigo QR amarrado y maleta con codigo QR grabado en el carrusel de un aeropuerto.",
	"Cuarto de instrumentos musicales. Estuche de un instrumento con un codigo QR grabado",
  ],
  en: [
    "Stainless steel bottle with QR code on the handle.",
    "Blue school lunchbox with QR label.",
    "Jacket hanging with QR code on the pocket.",
    "School cubby with backpacks and QR tags.",
    "Modern desk with laptop and QR-coded item.",
    "Pug dog with collar and QR ID tag.",
    "Key set with metallic QR keychain.",
    "Open leather wallet with engraved QR code.",
    "Orange sports cooler with logo and QR code.",
    "Mountain bike with QR code engraved on the frame.",
	"Suitcase with a tied QR code and suitcase with an engraved QR code on an airport carousel.",
	"Musical instrument room. Instrument case with an engraved QR code.",
  ],
  pt: [
    "Garrafa de aço inoxidável com código QR na alça.",
    "Lancheira escolar azul com etiqueta QR.",
    "Jaqueta pendurada com código QR no bolso.",
    "Armário escolar com mochilas e etiquetas QR.",
    "Escrivaninha moderna com laptop e item com QR.",
    "Cachorro pug com coleira e etiqueta QR de identificação.",
    "Conjunto de chaves com chaveiro metálico QR.",
    "Carteira de couro aberta com código QR gravado.",
    "Recipiente esportivo laranja com logotipo e QR code.",
    "Bicicleta de montanha com código QR gravado no quadro.",
	"Mala com código QR amarrado e mala com código QR gravado no carrossel de um aeroporto.",
	"Sala de instrumentos musicais. Estojo de um instrumento com um código QR gravado.",
  ]
};

  return (
    <section className="relative w-full bg-gray-100 pt-[90px] overflow-hidden">
    <div 
  className="relative mx-auto max-w-screen-2xl flex flex-col justify-center items-center"
  style={{ height: 'calc(var(--vh, 1vh) * 100 - 90px)' }}
	>

        {/* Imagen de fondo */}
        <div className="absolute inset-0 flex justify-center items-center">
          <div className="relative w-full h-full shadow-2xl overflow-hidden">
            <img
			src={images[current]}
			alt={altTexts[language][current]}
			className="w-full h-full object-cover"
			loading="eager"
/>
            <div className="absolute inset-0 bg-black/40 "></div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-white text-3xl md:text-5xl font-bold mb-4 drop-shadow-lg">
            {language === "es" && "Conectamos personas con sus objetos perdidos"}
            {language === "en" && "We connect people with their lost items"}
            {language === "pt" && "Conectamos pessoas aos seus objetos perdidos"}
          </h1>
          <p className="text-white text-lg md:text-2xl mb-6 drop-shadow-lg">
            {language === "es" && "Tecnología QR segura, simple y efectiva."}
            {language === "en" && "Secure, simple and effective QR technology."}
            {language === "pt" && "Tecnologia QR segura, simples e eficaz."}
          </p>
          <a
            href="#how"
            className="bg-turquoise-600 hover:bg-turquoise-700 text-white font-semibold py-3 px-8 rounded-full text-lg transition-transform transform hover:scale-105"
          >
            {language === "es" && "Explora cómo funciona"}
            {language === "en" && "Explore how it works"}
            {language === "pt" && "Explore como funciona"}
          </a>
        </div>

        {/* Controles de navegación */}
        <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex space-x-6 z-10">
          <button
            onClick={prevSlide}
            onKeyDown={(e) => e.key === 'Enter' && prevSlide()}
            aria-label="Slide anterior"
            className="bg-white/70 hover:bg-white/90 text-gray-700 rounded-full p-2 transition transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-turquoise-400 duration-300 ease-in-out"
          >
            <FiArrowLeft size={24} />
          </button>
          <button
            onClick={nextSlide}
            onKeyDown={(e) => e.key === 'Enter' && nextSlide()}
            aria-label="Slide siguiente"
            className="bg-white/70 hover:bg-white/90 text-gray-700 rounded-full p-2 transition transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-turquoise-400 duration-300 ease-in-out"
          >
            <FiArrowRight size={24} />
          </button>
        </div>

        {/* Dots de paginación */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-1 z-10">
		  {images.map((_, index) => (
			<button
			  key={index}
			  onClick={() => setCurrent(index)}
			  aria-label={`Ir al slide ${index + 1}`}
			  className={`transition-all duration-300 ease-in-out transform focus:outline-none ${
				current === index
				  ? 'text-turquoise-600 scale-125'
				  : 'text-gray-400 scale-100 opacity-60'
			  }`}
			>
			  <BsDot size={28} />
			</button>
		  ))}
		</div>
		
		

        {/* Botón de pausa/reanudar */}
        <button
          onClick={() => setPaused(!paused)}
          onKeyDown={(e) => e.key === 'Enter' && setPaused(!paused)}
          className="absolute top-6 right-6 bg-white/80 hover:bg-white/90 text-gray-700 font-medium py-1 px-4 rounded transition transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-turquoise-400 duration-300 ease-in-out z-10"
          aria-label={paused ? "Reanudar rotación" : "Pausar rotación"}
        >
          {paused ? '▶️' : '⏸️'}
        </button>

      </div>
    </section>
  );
}
